import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Politique de Confidentialité"
        description="Politique de confidentialité de lacrea.fr — collecte, utilisation et protection de vos données personnelles (RGPD)."
        path="/politique-confidentialite"
      />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-primary hover:underline mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1
          className="text-4xl font-bold mb-8"
        >
          Politique de Confidentialité
        </h1>

        <div className="prose prose-slate max-w-none space-y-8">
          <p className="text-muted-foreground leading-relaxed">
            <strong>Dernière mise à jour :</strong> 23 mars 2026
          </p>

          <section>
            <h2 className="text-2xl font-bold mb-4">
              1. Collecte des données
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Nous collectons les données personnelles suivantes lorsque vous
              utilisez notre formulaire de contact :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Nom de l'entreprise (optionnel)</li>
              <li>Budget estimé du projet (optionnel)</li>
              <li>Message / détails du projet</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">
              2. Utilisation des données
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Les données collectées sont utilisées exclusivement pour :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>Répondre à votre demande de contact</li>
              <li>Vous proposer un devis adapté à votre projet</li>
              <li>Vous recontacter dans le cadre de votre demande</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-2">
              Vos données ne sont jamais vendues, louées ou partagées avec des
              tiers à des fins commerciales.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">
              3. Conservation des données
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Les données du formulaire de contact sont conservées pendant une
              durée maximale de 3 ans à compter de votre dernière interaction
              avec nous, conformément aux recommandations de la CNIL.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">4. Cookies</h2>
            <p className="text-muted-foreground leading-relaxed">
              Ce site utilise des cookies analytiques (PostHog) pour comprendre
              comment les visiteurs interagissent avec le site. Ces cookies
              permettent de mesurer l'audience et d'améliorer l'expérience
              utilisateur. Aucun cookie publicitaire n'est utilisé.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">5. Vos droits</h2>
            <p className="text-muted-foreground leading-relaxed">
              Conformément au Règlement Général sur la Protection des Données
              (RGPD) et à la loi Informatique et Libertés, vous disposez des
              droits suivants :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1 mt-2">
              <li>Droit d'accès à vos données personnelles</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit à la portabilité</li>
              <li>Droit d'opposition au traitement</li>
            </ul>
            <p className="text-muted-foreground leading-relaxed mt-2">
              Pour exercer ces droits, contactez-nous à :{" "}
              <a
                href="mailto:contact@lacrea.fr"
                className="text-primary hover:underline"
              >
                contact@lacrea.fr
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">
              6. Responsable du traitement
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              Le responsable du traitement des données est Lacrea, joignable à
              l'adresse email : contact@lacrea.fr
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">7. Réclamation</h2>
            <p className="text-muted-foreground leading-relaxed">
              Si vous estimez que le traitement de vos données personnelles
              constitue une violation du RGPD, vous pouvez introduire une
              réclamation auprès de la CNIL (Commission Nationale de
              l'Informatique et des Libertés) :{" "}
              <a
                href="https://www.cnil.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                www.cnil.fr
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
